import { Grid, Typography } from '@mui/material';
import { COLORS } from 'services/constants/colors';
import { ETableStructureAlign, ETableStructureType } from 'ui/EasTable/types';
import { tableStructure } from '../../tableStructure';
import { EasTableValue } from 'ui/EasTable/EasTableRow/EasTableValue';
import { FC } from 'react';
import { TInvoiceDetailProps, TInvoiceListItemWithId } from '../types';

const isNullOrZero = (value: unknown) => {
	if (value === null || value === undefined) return true;
	const numeric = Number(value);
	if (Number.isNaN(numeric)) return false;
	return numeric === 0;
};

type RenderFieldProps = {
	item: TInvoiceListItemWithId;
	selector: keyof TInvoiceListItemWithId;
	label?: string;
	hideIfZero?: boolean;
	alwaysShowZero?: boolean;
	bold?: boolean;
	valueBold?: boolean;
	gridColumns?: [number, number];
	align?: ETableStructureAlign;
	value?: string | number | null;
	type?: ETableStructureType;
};

export const RenderField: FC<RenderFieldProps> = ({
	item,
	selector,
	label,
	hideIfZero,
	alwaysShowZero,
	bold,
	valueBold,
	gridColumns = [10, 2],
	align,
	value,
	type,
}) => {
	const column = tableStructure.find((col) => col.selector === selector && col.showInFoolData);

	if (!column) {
		return null;
	}

	const rawValue = value ?? (item as Record<string, unknown>)[selector as string];

	if (hideIfZero && isNullOrZero(rawValue)) {
		return null;
	}

	const valueToUse = alwaysShowZero && isNullOrZero(rawValue) ? 0 : rawValue;
	const textAlign = align ?? column.align ?? ETableStructureAlign.RIGHT;
	const labelToUse = label ?? column.name;

	return (
		<Grid container spacing={2} sx={{ width: '100%' }}>
			<Grid item md={gridColumns[0]}>
				<Typography
					sx={{
						color: COLORS.PRIMARY,
						fontSize: '1rem',
						fontWeight: bold ? 'bold' : 'normal',
					}}
				>
					{labelToUse}:
				</Typography>
			</Grid>
			<Grid item md={gridColumns[1]} sx={{ textAlign: textAlign }}>
				<EasTableValue
					type={type ?? column.type}
					tableStructureItem={column}
					value={valueToUse}
					item={item}
					size="l"
					bold={!!valueBold}
				/>
			</Grid>
		</Grid>
	);
};
